import React from 'react';
import PropTypes from 'prop-types';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
// import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { AuthContext } from '../../../authentication/Auth';
import moment from 'moment';
import firebaseUtil from '../../../data/FirebaseUtil';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from "react-router";
import Toolbar from './components/Toolbar';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import config from '../../../data/application.properties'
import { convertUtcToTimeZone } from '../../../data/dateTimeUtil';
import '../../css/reports.css'

const Heading = styled.div`
display:flex;
flex-direction:row;
align-items:center;
`;

const HeadingWithDate = styled.div`
display:flex;
flex-direction: column;
padding-left:10px;
`;

const Bold = styled.div`
font-weight:bold;
font-size:20px
`;

const StyledDate = styled.div`
color:gray;
font-size:15px;
`;

function createData(name, calories, fat, carbs, protein) {

  return { name, calories, fat, carbs, protein };
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'eventReportedAt', numeric: false, disablePadding: true, label: 'Date/Time' },
  { id: 'modelNumber', numeric: false, disablePadding: true, label: 'Device Model' },
  { id: 'serialNumber', numeric: false, disablePadding: true, label: 'Serial' },
  { id: 'friendlyName', numeric: false, disablePadding: true, label: 'Device Name' },
  { id: 'userId', numeric: false, disablePadding: true, label: 'User' },
  { id: 'apFriendlyName', numeric: false, disablePadding: true, label: 'AP Location' },
  { id: 'connectionState', numeric: false, disablePadding: true, label: 'Connection' },
  { id: 'batteryLevel', numeric: false, disablePadding: true, label: 'Battery%' },
  { id: 'isCharging', numeric: false, disablePadding: true, label: 'Charging' },
  { id: 'siteName', numeric: false, disablePadding: true, label: 'Site' }
];

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell,i) => (
          <TableCell
            key={headCell.id}
            align="left"
            padding="default"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              { i===0?<p className='report-table-padding'>{headCell.label}</p>:headCell.label }
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc','']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = (props) => {
  const history = useHistory();
  const classes = useToolbarStyles();
  const { totalCount } = props;
  let searchparam = history?.location?.state;
  return (
    <Toolbar history={history} 
    fromDate={moment(searchparam?.fromDate).format('YYYY-MM-DD')}
    toDate={moment(searchparam?.toDate).format('YYYY-MM-DD')}
    siteName={searchparam?.siteName}
    category ={searchparam?.category}
    subCategory ={searchparam?.subCategory}
    deviceStateUpdatedBy ={searchparam?.deviceStateUpdatedBy}
    totalCount={totalCount}/>
      
    // <Toolbar>
    //   {
    //     history?.location?.state?.deviceStateUpdatedBy === 0 ||
    //       history?.location?.state?.deviceStateUpdatedBy === 1
    //       ?
    //       <div><span>{history?.location?.state?.deviceStateUpdatedBy === 0 ? "MANUAL" : "AUTOMATIC"}</span> <br />{totalCount} set {history?.location?.state?.deviceStateUpdatedBy === 0 ? "Manually" : "Automatically"}</div>
    //       :
    //       <div><span>{history?.location?.state?.category}</span> </div>
    //   }
      
    // </Toolbar>
  );
};


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));
var searchparam = {
  fromDate: moment().subtract(1, "day").valueOf(),
  toDate: moment().valueOf(),
  siteName: ""
}

export default function EnhancedTable() {
  const classes = useStyles();
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rows, setRows] = React.useState([])
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const history = useHistory();
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const dateRange = {fromDate:history?.location?.state?.fromDate, toDate:history?.location?.state?.toDate};
  const siteName = history?.location?.state?.siteName;
  const context = useContext(AuthContext);

  useEffect(() => {
    setLoggedInUser(context.currentUser.email);
    getData(0);
  }, []);

  async function getData(pageNumber, pageSize = null, isSort = false) {
    console.log('searchparam', searchparam);
    console.log("currentPageSize:" + pageSize);
    console.log("history?.location?.state", history?.location?.state);
    searchparam = history?.location?.state;
    searchparam = {
      ...searchparam,
      startDate: moment(searchparam?.fromDate).format('YYYY-MM-DD'),
      endDate: moment(searchparam?.toDate).format('YYYY-MM-DD'),
      pageNumber: pageNumber,
      pageSize: pageSize ? pageSize : rowsPerPage
    }
    if (isSort) {
      searchparam = {
        ...searchparam,
        orderByCol: orderBy,
        sortingOrder: order
      }
    }
    console.log("serch params are", searchparam);
    fetchSiteEventData(searchparam);
  }


  const fetchSiteEventData = (requestBody) => {
    setIsLoading(true);
    firebaseUtil.sendIndividualSiteEvents(requestBody).then(response => {
      console.log("response.data.rows", response.data.rows.length);
      setRows(response.data.rows);
      setTotalCount(response.data.count);
      setIsLoading(false);
    })
      .catch(err => {
        setIsLoading(false);
        console.log("Error in getting the site events", err);
      })
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

  };
  useEffect(() => {
    if (order && orderBy) {
      console.log("order is", order);
      console.log("order by is", orderBy);
      getData(page, rowsPerPage, true);
    }
  }, [order, orderBy])

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(newPage);

  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getData(0, parseInt(event.target.value, 10));
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper} style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1', position: 'relative' }}>
        {
          isLoading && <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
            <CircularProgress color="primary"/>
          </div>
        }
          <Heading style={{paddingLeft: 25,paddingTop: 20}}>
            <div>
              <Button variant="contained" onClick={()=>history?.location?.state?.backToEventCount ? history.go(-2) : history.goBack()} startIcon={<ArrowBackIcon />} />
            </div>
            <HeadingWithDate>
              <Bold>{siteName}</Bold>
              <StyledDate>{moment(dateRange.fromDate).format('YYYY/MM/DD')} - {moment(dateRange.toDate).format('YYYY/MM/DD')}</StyledDate>
            </HeadingWithDate>
          </Heading>
        <EnhancedTableToolbar totalCount={totalCount} />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            
            <TableBody>
              {
                rows.map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={"row-"+index}
                    >
                      <TableCell align='left'>
                        <p className='report-table-padding'>{row.eventReportedAt ? convertUtcToTimeZone(row.eventReportedAt , row?.timeZoneActual) : row.reportedAt_Day.value}</p>
                      </TableCell>
                      <TableCell align='left'>
                        {row.modelNumber?row.modelNumber:<></>}
                      </TableCell>
                      <TableCell align="left">{row.serialNumber?row.serialNumber:<></>}</TableCell>
                      <TableCell align="left">{row.friendlyName?row.friendlyName:""}</TableCell>
                      <TableCell align="left">{row.userId?row.userId:<></>}</TableCell>
                      <TableCell align="left">{row.apFriendlyName?row.apFriendlyName:row.apMacAddress}</TableCell>
                      <TableCell align="left">{
                        row.connectionState == 0?"Never Connected":row.connectionState == 1?'Connected':'Not Connected'
                      }
                      </TableCell>
                      <TableCell align="left">{row.batteryLevel?row.batteryLevel:<></>}</TableCell>
                      <TableCell align="left">{row.isCharging?'Charging':"Not charging"}</TableCell>
                      <TableCell align="left">{row.siteName?row.siteName:<></>}</TableCell>
                    </TableRow>
                  );
                })
              }
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
